import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { SelectCargoGrupo } from "../../../../components/selects/cargoGrupo";
import { SelectCargo } from "../../../../components/selects/cargo";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";

export const CargoEdit = () => {
  const { goBack, navTo } = useNav();

  const { startLoading, stopLoading, isLoading } = useLoading();
  const { setMensagemSuccess, setMensagemError } = useErrorSuccess();

  const { id } = useParams();

  const getCargo = async () => {
    let req = await api.get("ministerio/cargo/geral/v2/buscar/" + id);
    setValue("cargopai", req.data?.cargopai);
    setValue("codigo", req.data?.codigo);
    setValue("observacoes", req.data?.observacoes);
    setValue("descricao", req.data?.descricao);
    return;
  };

  const { register, watch, handleSubmit, setValue } = useForm<{
    descricao: string;
    codigo: string;
    grupo: number;
    cargopai: number;
    observacoes: string;
  }>({
    defaultValues: {
      descricao: null,
      cargopai: null,
      observacoes: null,
      codigo: null,
      grupo: null,
    },
  });

  useEffect(() => {
    getCargo();
  }, []);

  const put = handleSubmit(async (values) => {
    startLoading();
    try {
      await api.put("ministerio/cargo/geral/" + id, values);
      setMensagemSuccess("Alterado com sucesso!");
      goBack();
    } catch (error) {
      setMensagemError(
        JSON.stringify(error?.response?.data?.mensagem, null, 2) ||
          "Erro ao alterar usuário"
      );
    } finally {
      stopLoading();
    }
  });

  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal props={{ display: "grid", rowGap: 1 }}>
          <FormControl fullWidth>
            <TextField
              {...register("descricao")}
              label="Descrição"
              sx={{ width: "100%" }}
            />
          </FormControl>
          <FormControl fullWidth sx={{ margintTop: 2 }}>
            <TextField
              {...register("codigo")}
              label="Código"
              sx={{ width: "100%" }}
            />
          </FormControl>
          <SelectCargoGrupo
            action={(grupo) => {
              setValue("grupo", grupo?.target?.value);
            }}
            valor={watch("grupo")}
          />
          <SelectCargo
            titulo="Cargo Pai"
            action={(cargo) => {
              setValue("cargopai", cargo?.target?.value);
            }}
            valor={watch("cargopai")}
          />
          <FormControl fullWidth>
            <FormLabel>Observações</FormLabel>
            <TextareaAutosize
              {...register("observacoes")}
              style={{
                width: "100%",
                minHeight: 60,
                borderRadius: 4,
                borderColor: "#ccc",
                resize: "none",
                padding: "4px 8px",
              }}
            />
          </FormControl>
          <div
            style={{
              display: "flex",
              marginTop: 8,
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button variant="contained" disabled={isLoading} onClick={put}>
              Confirmar
            </Button>
            <Button variant="contained" color="error" onClick={goBack}>
              Cancelar
            </Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  );
};
